import { Box, Divider } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import Footer from "components/layout/footer/Footer";
import Assistant from "components/layout/header/assistant/Assistant";
import Blog from "components/layout/main/blog/Blog";
import { PostConfirmationMessageRender } from "components/layout/post-confirmation";
import { CACHE_KEYS } from "constants/common";
import { useIsMobile } from "hooks/useIsMobile";
import React, { useEffect } from "react";
import { getGuestConfirmationSettings } from "services/api/user.service";
import { ReactComponent as Logo } from "../../images/valoo-logo.svg";
import styles from "../layout/header/Header.module.css";

const GuestConfirmationSettings = ({ userType }) => {
  const { data, isLoading, isError } = useQuery({
    queryFn: () => getGuestConfirmationSettings(userType),
    queryKey: [CACHE_KEYS.CONFIRMATION_SETTINGS, userType],
  });

  useEffect(() => {
    // Scroll to the top when the component mounts or updates
    window.scrollTo(0, 0);
  }, []);

  const isMobile = useIsMobile();


  return (
    <Box>
      {isMobile ? (
        // Mobile version
        <>
          <div className="separatorEmptyMedium"></div>
          <header className={`${styles.container}`}>
            <div className={styles.logoContainer}>
              <Logo alt="Valoo Logo" className={styles.logo} />
            </div>
            <div>
              <Assistant />
            </div>
          </header>
          <div className="separatorEmptyMedium"></div>
        </>
      ) : (
        // Desktop version
        <>
          <header className={`${styles.container} maxWidth marginAuto`}>
            <div className={styles.logoContainer}>
              <Logo alt="Valoo Logo" className={styles.logo} />
            </div>
            <div>
              <Assistant />
            </div>
            <div>
            </div>
          </header>
        </>
      )}
      <Box sx={{}} className="secondBackground">
        <div className="maxWidth marginAuto">
          <div className="separatorEmptyLarge"></div>
          <PostConfirmationMessageRender
            isLoading={isLoading}
            isError={isError}
            data={data}
          />
          <div className="separatorEmptyLarge"></div>
          <Divider variant="middle" />
          <div className="separatorEmptyLarge"></div>
          <Blog />
        </div>
      </Box>
      <Footer />
    </Box>
  );
};

export default GuestConfirmationSettings;
